// Placeholders for the two cliente routes that resolve but are not built yet:
// /desarrollos/cliente/mi-anexo and /desarrollos/cliente/intake-manual.

import { ArrowLeft } from 'lucide-react';
import SivarSendWordmark from '../../components/brand/SivarSendWordmark';
import ClienteActions from './ClienteActions';

const ClientePlaceholder = ({ title, body, onBack, onNavigate }) => (
  <div className="min-h-screen bg-[#f8fafc] p-5">
    <div className="max-w-3xl mx-auto pt-6">
      <div className="flex items-start justify-between gap-4 mb-6">
        <SivarSendWordmark size="md" />
        {onNavigate && <ClienteActions onNavigate={onNavigate} />}
      </div>
      <div className="bg-white border border-slate-200 rounded-2xl p-6">
        <p className="text-sm font-bold text-slate-900">{title}</p>
        <p className="mt-2 text-xs text-slate-500 leading-relaxed">{body}</p>
        <button
          type="button"
          onClick={onBack}
          className="mt-5 inline-flex items-center gap-1.5 min-h-[44px] text-xs font-bold text-slate-600 hover:text-slate-900 transition-colors"
        >
          <ArrowLeft size={13} />
          Volver
        </button>
      </div>
    </div>
  </div>
);

export default ClientePlaceholder;
